import { useState } from 'react';
import '../../App.css'; 
import eyeOpenIcon from '../../assets/img/eye.svg'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { passwordClipboardProps } from '../../utils/passwordClipboard';


function Login() {
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState({
    userName: '',
    password: ''
  });
  const [rememberMe, setRememberMe] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const handelChange = (e)=>{
    const {name, value} = e.target;
    setAdminData({
      ...adminData,
      [name]: value
    });
  }
  const handleSubmit = async(event) => {
    event.preventDefault(); 
    console.log('Admin Data:', adminData);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/adminuser/adminLogin`,
        {
          username: adminData.userName,
          password: adminData.password,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if(response){
        const { token, admin } = response.data;
  
        localStorage.setItem("adminToken", token);
      
        localStorage.setItem("admin", JSON.stringify(admin));
        window.dispatchEvent(new Event("storage"));
  
       toast.success('Login Successful!');
        navigate("/adminDashboard");

      }
    } catch (err) {
      console.error("Login Error:", err);
      if (err.response) {
      toast.error('Invalid username or password!');
    } else {
      toast.error('Login failed. Please check your network connection.');
    }
    } 
  };

  return (
    <div className="container-fluid login-container">
      <div className="left-panel d-none d-md-block">
        <div className="left-overlay">
          <div className="headingbox">
            <h1>The Future <br />Through Space</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur. Lorem posuere at odio
              nullam pulvinar enim consequat at vitae. Elit ullamcorper ultrices
              magna malesuada erat.
            </p>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="right-panel">
        <div className="login-box">
          <div className="welcomeheading">
            <h2 className="text-red fw-bold mb-4">Welcome Back</h2>
            <p>Enter your Username and password to access your account</p>
          </div>

          <form onSubmit={handleSubmit} >
            <div className="mb-4">
              <label className="form-label">Username</label>
              <input
                type="userName"
                name="userName"
                className="form-control"
                placeholder="Enter your userName"
                value={adminData.userName}
                onChange={handelChange}
                required
              />
            </div>

            <div className="mb-2 position-relative">
              <label className="form-label">Password</label>
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-control"
                id="password"
                name="password"
                placeholder="Enter your password"
                value={adminData.password}
                onChange={handelChange}
                {...passwordClipboardProps}
                required
              />
              <span
                id="togglePassword"
                onClick={() => setShowPassword(!showPassword)}
              >
                <img src={eyeOpenIcon} alt="Show password" />
              </span>
            </div>

            <div className="form-check mb-4">
              <input
                type="checkbox"
                className="form-check-input"
                id="remember"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label className="form-check-label rememberme" htmlFor="remember">
                Remember me
              </label>
            </div>

            <button
              type="submit"
              className="btn btn-dark text-decoration-none rounded-3 ft-15 mt-4 w-100"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
